/**
 * Bytes16 size in bytes (16 bytes = 128 bits)
 */
export const SIZE = 16;

/**
 * Zero Bytes16 constant (16 zero bytes)
 * @type {import('./Bytes16Type.js').Bytes16Type}
 */
export const ZERO = /** @type {import('./Bytes16Type.js').Bytes16Type} */ (
	new Uint8Array(SIZE)
);

/**
 * @typedef {import('./Bytes16Type.js').Bytes16Type} Bytes16Type
 */
